export const ADD_DANGER_ALERT = 'ADD_DANGER_ALERT';
export const ADD_ERROR_ALERT = 'ADD_ERROR_ALERT';
export const ADD_REFRESH_ALERT = 'ADD_REFRESH_ALERT';
export const ADD_SUCCESS_ALERT = 'ADD_SUCCESS_ALERT';
export const ADD_WARNING_ALERT = 'ADD_WARNING_ALERT';
export const REMOVE_REFRESH_ALERT = 'REMOVE_REFRESH_ALERT';